import React, { useEffect, useState } from "react";
import {Getauth,Removeauth} from "../services/Auth"
import { useSelector } from 'react-redux'
import { useDispatch } from "react-redux";
import { delAllCart } from "../redux/action";
import { GetUserRole } from "../services/UserRole";
import {
  Search,
  KeyboardArrowDown,
  AccountCircle,
  ShoppingCart,
  NotificationsNone,
  FavoriteBorderOutlined,
  KeyboardArrowUp,
  Menu,
  Close,
} from "@mui/icons-material";
import { Link, Navigate, NavLink, useNavigate } from 'react-router-dom';
import Login from "./Login";
import Registeration from "./Registeration";
import { RemoveUserRole } from "../services/UserRole";
import axios from "axios";
import { setHeader } from "../services/Headers";
import { Url } from "../services/Constants";
import { CartUpdate } from "../services/CartUpdate";

export default function Navbar({profilePic,roleHandle, setSearch = () => {}}) {

    const [login, setLogin] = useState(false)
    const [register, setRegister] = useState(false)
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [usertype, setUserType] = useState(false)  // true:a seller, false:a buyer  By default a buyer
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isCategoryOpen, setIsCategoryOpen] = useState(false);
    const [isAccountOpen, setIsAccountOpen] = useState(false);
    const [isSearchOn, setIsSearchOn] = useState(false)
    const [userProfile, setUserProfile]  = useState()
    const [isSeller,setIsseller] = useState(false)

    const [productCategory, setProductCategory] = useState([])

    const state = useSelector((state) => state.handleCart)
    const dispatch = useDispatch();
    const userRole = GetUserRole();
    const navigate = useNavigate();
    const favorites = useSelector((state) => state.handleFavorites)
    const [searchInput, setSearchInput] = useState("");


    useEffect(()=>{
      const auth = Getauth()
      if(auth){
        setIsLoggedIn(true)
        getUserProfile()
      }
      
    },[login,register,state])

    useEffect(()=>{
      getCategory()
    },[])

    async function getUserProfile(){
      
      if(userRole === "buyer"){
      try {
          const result = await axios.get(`${Url}/buyer/get_profile`,setHeader())
          setUserProfile(result.data.response_data)
          
        }catch (error) {
        console.log(error)
        }
    }else if(userRole === "seller"){
      try {
        const result = await axios.get(`${Url}/seller/get_profile`,setHeader())
        setUserProfile(result.data.response_data)
        setIsseller(true)
      }catch (error) {
      console.log(error)
      }
    }else{
      Removeauth()
      RemoveUserRole()
      setIsLoggedIn(false);
      navigate('/');
    }
  }

  const profileClick = ()=>{
    navigate("/profile/user")
  }

    const loginHandle=()=>{
      setLogin(!login)
    }

    const loggedinHandle = ()=>{
      setIsLoggedIn(!isLoggedIn)
 
    }


    const registerHandle=()=>{
      setRegister(!register)
    }

    const logOutHandle = (e) => {
      dispatch(delAllCart());
      Removeauth()
      RemoveUserRole()
      CartUpdate()
      localStorage.clear("rzp_checkout_anon_id")
      localStorage.clear("rzp_device_id")
      localStorage.clear("rzp_stored_checkout_id")
      navigate('/');
    }
    const toggleMenu = () => {
      setIsMenuOpen(!isMenuOpen);
    };
 
    const homeRole=()=>{
      roleHandle()
    }

    const handleSearchChange = (e) => {
      const searchValue = e.target.value;
      setSearchInput(e.target.value);
      setSearch(searchValue);
    };

    const handleSearchSubmit = () => {
      navigate('/products');
    };

    const getCategory = async()=>{
      try {
        const result = await axios.get(`${Url}/categories`)
        // console.log(result.data.response_data.categories)
        setProductCategory(result.data.response_data.categories)
      } catch (error) {
        console.log(error)
      }
    }

  return (
    <>
      <div className="navbar-container max-h-24 w-full h-24 shadow-xl bg-white rounded-b-lg flex flex-row items-center max-sm:h-16">
        <div className="navbar-left flex justify-center items-center h-full basis-32">
          <NavLink to="/">
            <img className="h-9 flex ml-2 cursor-pointer w-auto max-sm:h-5" src="../assets/Logo.png" alt="logo.png" />
          </NavLink>
        </div>
        <div className="navbar-center flex basis-5/12 justify-center items-center w-full max-sm:basis-[60%] max-lg:basis-[75%] max-sm:justify-end">
          <div className="bg-red-50 w-full rounded-xl text-black flex items-center  md:w-4/5 max-sm:w-auto max-sm:rounded-full">
          <div className="search max-sm:hidden">
            <Search className="pl-2 text-gray-700 cursor-pointer max-sm:m-1 max-sm:p-0 "  />
          </div>
            {!isSearchOn?
            <div className="search sm:hidden">
              <Search className="pl-2 text-gray-700 cursor-pointer max-sm:m-1 max-sm:p-0 " onClick={()=>setIsSearchOn(!isSearchOn)} />
            </div>:""}
            <input
              type="text"
              value={searchInput}
              onChange={handleSearchChange}
              onClick={handleSearchSubmit}
              className="h-9 bg-red-50 ml-1 pl-1 text-sm focus:outline-none w-full md:w-4/5 placeholder:text-xs md:placeholder:text-sm max-sm:hidden"
              placeholder="Search Product..."
            />
          </div>
          {isSearchOn?<div className="search-bar-mobile w-full absolute top-[65px] left-0 sm:hidden z-[999]">
          <div className="bg-red-50 w-[99%] mx-auto rounded-2xl text-black flex items-center">
            <Search className="pl-2 text-gray-700 cursor-pointer" />
            <input
              type="text"
              value={searchInput}
              onChange={handleSearchChange}
              onClick={handleSearchSubmit}
              className="h-9 bg-red-50 ml-1 pl-1 text-sm focus:outline-none w-[85%] placeholder:text-xs md:placeholder:text-sm "
              placeholder="Search Product..."
            />
            <Close className="mx-auto text-gray-700 cursor-pointer" onClick={()=>setIsSearchOn(!isSearchOn)}/>
          </div>
          </div>:""}
        </div>
        


        {/* Sidebar for mobile */}
        <div className="mobile-navbar-menu basis-[10%] lg:hidden">
          <div className="menu-container flex items-center">
         
          {!isSeller?<><li className="nav-item flex ">
            <NavLink to="/cart" className={({ isActive }) => `block ${isActive ? 'text-amber-950 border-b border-b-amber-950' : 'text-amber-950'}`}>
              <ShoppingCart className="cursor-pointer " />
            </NavLink>
              <div className="h-4 w-4 bg-red-600 rounded-full relative right-1 bottom-2 text-white flex justify-center text-center font-bold ">
                <span className="text-xs">{state?state.length:"0"}</span>
              </div>
            </li></>:<><li className="nav-item flex mr-1">
            <NavLink to="/order-history" className={({ isActive }) => `block ${isActive ? 'text-amber-950 border-b border-b-amber-950' : 'text-amber-950'}`}>
              <img src="../assets/box.png" alt="" className="k h-6 w-6 max-sm:ml-2 max-sm:mr-6 " />
            </NavLink>
            </li></>}
            {!isSeller&&isLoggedIn?<><li className="nav-item flex ">
              <NotificationsNone className="cursor-pointer hover:text-gray-600" />
              <div className="h-4 w-4 bg-red-600 rounded-full relative right-[10px] bottom-2 text-white flex justify-center text-center font-bold ">
                <span className="text-xs">0</span>
              </div>
            </li>

            
            <li className="nav-item flex mr-2">
              <NavLink to="/favorites">
                <FavoriteBorderOutlined className="cursor-pointer hover:text-red-600" />
              </NavLink>
              <div className="h-4 w-4 bg-red-600 rounded-full relative right-[10px] bottom-2 text-white flex justify-center text-center font-bold ">
                <span className="text-xs">{favorites ? favorites.length : "0"}</span>
              </div>
            </li></>:""}
            
          <Menu className="mr-2" onClick={()=>setIsMenuOpen(!isMenuOpen)}/>
          </div>
          {isMenuOpen?<div className={`menu-container bg-white text-amber-950 border-l-2 border-l-gray-200 h-lvh w-[35%] absolute z-50 right-0 top-0 p-3 ease-in-out duration-500 max-sm:w-[60%] ${isMenuOpen ? "right-0" : "-right-full"}`}>
          <div className="close-btn text-right">
          <Close sx={{ fontSize:28 ,stroke: "#3b1c01", strokeWidth:2 }} className=" mb-8  text-amber-950 w-[20%] hover:bg-amber-950 hover:stroke-white cursor-pointer max-md:ml-0" onClick={()=>{setIsMenuOpen(!isMenuOpen);setIsCategoryOpen(false);setIsAccountOpen(false)}} />
          </div>
          {isLoggedIn?<div className="profile border-b border-b-amber-950 ">
            <NavLink to="/profile/user" className={({ isActive }) =>`block ${isActive ? 'text-gray-600 font-bold' : 'hover:text-gray-600'}`}>
          <img
                src={ profilePic || userProfile?.profile_pic||"../assets/profile_pic.webp"}
                className="object-cover w-16 h-16 cursor-pointer rounded-full border-2 border-amber-950 mx-auto mb-2"
                alt="profile_pic"
              />
              </NavLink>
          </div>:
          <div className="login-container  border-b border-b-amber-950">
            <span className="login-btn bg-amber-950 w-[40%] mx-auto text-white rounded-lg text-center py-[1%] flex items-center justify-center mb-2" onClick={()=>{loginHandle();toggleMenu()}}>Login</span>
          </div>}
          <div className="home-container">
            <span className="home"><NavLink to={"/"}>Home</NavLink></span>
          </div>
          <div className="aboutus-container">
            <span className="aboutus"><NavLink to={"/about"}>About Us</NavLink></span>
          </div>
          <div className="products-container">
            <span className="products"><NavLink to={"/products"}>Products</NavLink></span>
          </div>
          <div className="categories-container" onClick={()=>{setIsCategoryOpen(!isCategoryOpen);setIsAccountOpen(false)}}>
            <div className="products-category flex justify-between">
              <span className="category">Category</span>
              <KeyboardArrowDown/>
            </div>
            {isCategoryOpen?<ul className="products-category-list ml-3">
              {productCategory?.map((cat)=>(<li className="k"><NavLink to={`/products?category_id=${cat.id}`} className={({ isActive }) => `block ${isActive ? 'text-amber-950' : 'text-amber-950'}`}>
                  {cat.name}
                  </NavLink></li>))}
            </ul>:""}
          </div>
          
          {isLoggedIn?<div className="logout mt-5">
            <span className="bg-amber-950 w-[60%] mx-auto text-white rounded-md  text-center py-1 px-2 flex items-center justify-center" onClick={logOutHandle}>Log Out</span>
          </div>:""}
          </div>:""}
        </div>
        


        {/* Main Navbar Menu */}
        <div className="navbar-menu flex-col items-center justify-between basis-7/12 w-full bg-white static top-20 left-0 z-40 max-lg:hidden">
          <ul className={`flex justify-evenly items-center w-full ${isMenuOpen ? "hidden" : "flex"}`}>
            <li className="nav-item cursor-pointer">
              <NavLink to="/" className={({ isActive }) => `block ${isActive ? 'text-amber-950 underline font-semibold' : 'text-amber-950'}`}>
                Home
              </NavLink>
            </li>
            <li className="nav-item cursor-pointer">
            <NavLink to="/about" className={({ isActive }) => `block ${isActive ? 'text-amber-950 underline font-semibold' : 'text-amber-950'}`}>
                About Us
              </NavLink>
            </li>
            <li className="nav-item cursor-pointer">
            <NavLink to="/products" className={({ isActive }) => `block ${isActive ? 'text-amber-950 underline font-semibold' : 'text-amber-950'}`}>
                Products
            </NavLink>
            </li>
            <li id="dropdownHoverButton" className="nav-item group cursor-pointer hover:text-gray-600">
              <div className="categories-hover group/category">
                <span className="text-amber-950">Categories</span>
                <KeyboardArrowDown className="arrowDowntext-amber-950 group-hover:hidden"/>
                <div className="arrowUp m-0 p-0 hidden group-hover:visible group-hover:inline">
                <KeyboardArrowUp className="arrowUp text-amber-950"/>
                </div>
              </div>
              <ul className="invisible absolute top-16 2xl:w-[12%] z-50 text-base flex w-[18%] rounded-b-sm shadow-lg flex-col items-center bg-gray-50 text-black group-hover:visible ">
                <div className="bg-white w-full flex justify-center">
                  {/* <div className="w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-b-[22px] border-b-gray-200 bg-white"></div> */}
                </div>
                {productCategory?.map((cat)=>(<li key={cat.id} className="my-1 mt-2 block hover:text-gray-600 hover:border-b-4 border-b-amber-900 md:mx-2">
                <NavLink to={`/products?category_id=${cat.id}`} className={({ isActive }) => `block ${isActive ? 'text-amber-950' : 'text-amber-950'}`}>
                  {cat.name}
                  </NavLink>
                </li>))}
              </ul>
            </li>
            {!isSeller?<><li className="nav-item flex ">
            <NavLink to="/cart" className={({ isActive }) => `block ${isActive ? 'text-amber-950 border-b border-b-amber-950' : 'text-amber-950'}`}>
              <ShoppingCart className="cursor-pointer " />
            </NavLink>
              <div className="h-4 w-4 bg-red-600 rounded-full relative right-1 bottom-2 text-white flex justify-center text-center font-bold ">
                <span className="text-xs">{state?state.length:"0"}</span>
              </div>
            </li></>:<><li className="nav-item flex mr-1">
            <NavLink to="/order-history" className={({ isActive }) => `block ${isActive ? 'text-amber-950 border-b border-b-amber-950' : 'text-amber-950'}`}>
              <img src="../assets/box.png" alt="" className="k h-6 w-6" />
            </NavLink>
            </li></>}
            {!isSeller&&isLoggedIn?<><li className="nav-item flex ">
              <NotificationsNone className="cursor-pointer hover:text-gray-600" />
              <div className="h-4 w-4 bg-red-600 rounded-full relative right-[10px] bottom-2 text-white flex justify-center text-center font-bold ">
                <span className="text-xs">0</span>
              </div>
            </li>

           

            <li className="nav-item flex ">
              <NavLink to="/favorites">
                <FavoriteBorderOutlined className="cursor-pointer hover:text-red-600" />
              </NavLink>
              <div className="h-4 w-4 bg-red-600 rounded-full relative right-[10px] bottom-2 text-white flex justify-center text-center font-bold ">
                <span className="text-xs">{favorites ? favorites.length : "0"}</span>
              </div>

            </li></>:""}
            {!isLoggedIn?<li className="nav-item cursor-pointer text-amber-950 hover:text-gray-600" onClick={loginHandle} >
              <AccountCircle className="mr-1" />
              Login
            </li>:
            <li id="dropdownHoverButton" className="nav-item group cursor-pointer hover:text-gray-600">
              <div className="profile-hover w-10 h-10 border-2 border-gray-400 rounded-full hover:border-black" onClick={profileClick}>
              <img
                src={profilePic || userProfile?.profile_pic ||  "../assets/profile_pic.webp"}
                className="object-cover w-full h-full cursor-pointer rounded-full"
                alt="profile_pic"
              />
              </div>
              
            </li>}
          </ul>
        </div>
      </div>

      {register?<Registeration data={{registerHandle,register,loginHandle,usertype,loggedinHandle}}/>:""}
      {login?<Login data={{loginHandle,login,registerHandle,usertype,homeRole,loggedinHandle}}/>:""}
      </>
  );
}
